import template from './purchasingAccounts.html';
import controller from './purchasingAccounts.controller';

let purchasingAccountsComponent = {
  restrict: 'E',
  bindings: {
    customer: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default purchasingAccountsComponent;



// WEBPACK FOOTER //
// ./app/components/purchasingAccounts/purchasingAccounts.component.js